/**
 * Retorna a forma abreviada.
 *
 * true = Útil
 *
 * false = Não Útil
 */
const abreviar = {
	Útil: true,
	'Não Útil': false,
}

/**
 * Retorna a palavra completa juntamente com a classe que deve ser aplicada caso use o componente Tag.
 *
 * true = Útil
 *
 * false = Não Útil
 */
const desabreviar = {
	true: 'Útil',
	false: 'Não Útil',
}

export { abreviar, desabreviar }
